import React from "react";
import PropTypes from 'prop-types';
import { Tab, Pagination } from 'semantic-ui-react';

import './gallery-container.scss';

import CustomGallery from './CustomGallery';
import { assetUrl } from '../../../utils/graphqlClient';

const DEFAULT_DESCRIPTION =
  '*A fuller story for this photograph is on its way, and will be shared here soon.*';

class GalleryCont extends React.Component {
  constructor(props) {
    super(props);
    const allLabel = props.labels.find((label) => String(label.name).toLowerCase() === 'all');
    this.state = {
      activeTabId: allLabel ? Number(allLabel.id) : (props.labels[0]?.id || 1),
      modalIsOpen: false,
      currentImage: 0,

      /* PAGINATION PART */
      boundaryRange: 1,
      siblingRange: 1,
      showEllipsis: true,
      showFirstAndLastNav: true,
      showPreviousAndNextNav: true,
      activePage: 1,
      offset: 0,
      perPage: this.props.perPage,
      /* END OF PAGINATION PART */

      showLightBox: false,
      index: '',
      left: '',
      top: '',
      key: '',
      photo: '',

      hoverPicture: false,
    };
  }

  handleActiveTab = (evt, data) => {
    const allLabel = this.props.labels.find((label) => String(label.name).toLowerCase() === 'all');
    const allLabelId = allLabel ? Number(allLabel.id) : null;
    const usedLabelIds = new Set(
      this.props.pictures
        .map((picture) => picture.labelId)
        .filter((labelId) => labelId !== null && labelId !== undefined)
        .map((labelId) => Number(labelId))
    );

    const visibleLabels = this.props.labels.filter((label) => {
      const labelId = Number(label.id);
      if (allLabelId !== null && labelId === allLabelId) {
        return true;
      }
      return usedLabelIds.has(labelId);
    });

    const selectedLabel = visibleLabels[data.activeIndex];
    this.setState({
      activeTabId: selectedLabel ? Number(selectedLabel.id) : this.state.activeTabId,
      offset: 0,
    });
  };

  handleShow = (evt, data) => {
    this.setState({
      active: true,
      modalIsOpen: true,
      currentImage: Number(this.state.offset === 0 ? data.index : ( this.state.offset + data.index) ),
    });
  };

  handleHide = () => {
    this.setState({ modalIsOpen: false });
  };

  handlePaginationChange = (e, { activePage }) => this.setState({ 
    activePage, 
    offset: (activePage - 1) * this.props.perPage,
  })

  handleLightBox = (e, { index, left, top, key, photo }) => {
    this.setState({
      showLightBox: true,
      index,
      left,
      top,
      key,
      photo
    });
  }

  render() {

    const {
      activeTabId,
      /* PAGINATION PART */
      activePage,
      boundaryRange,
      siblingRange,
      showEllipsis,
      showFirstAndLastNav,
      showPreviousAndNextNav,
      offset,
      perPage,
      /* PAGINATION PART */
    } = this.state;

    const allLabel = this.props.labels.find((label) => String(label.name).toLowerCase() === 'all');
    const allLabelId = allLabel ? Number(allLabel.id) : null;

    // Je reformate mon array pour convenir au Composant étranger Gallery suivant leur doc en lui passant également les infos que j'aurai besoin pour l'affichage de ma lightbox
    const galleryPictures = this.props.pictures.map((picture, i) => (
      {
        id: Number(`${picture.id}`),
        key: `${i}`,
        title: `${picture.name}`,
        place: `${picture.place}`,
        caption: picture.description && String(picture.description).trim().length > 0
          ? String(picture.description)
          : DEFAULT_DESCRIPTION,
        src: assetUrl(`uploads/${picture.original || picture.src || picture.thumb}`),
        fullsize: assetUrl(`uploads/${picture.original || picture.src}`),
        customclass: `${picture.customClass}`,
        width: Number(`${picture.customClass === 'thumb-paysage' ? 4 : 2}`),
        height: 3,
        labelid: picture.labelId !== null && picture.labelId !== undefined ? Number(picture.labelId) : null,
        likes: Number(`${picture.likes}`),
        make: `${picture.make}`,
        model: `${picture.model}`,
        exposure: `${picture.exposure}`,
        fnumber: `${picture.fnumber}`,
        iso: `${picture.iso}`,
        focaldistance: `${picture.focalDistance}`,
        shootingdate: `${picture.shootingDate}`,
        lensinfo: `${picture.lensInfo}`,
        lensmodel: `${picture.lensModel}`,
        loading: i < 3 ? 'eager' : 'lazy',
      }
    ));

    // Si la category est all je veux tous les posts sinon je filtre
    const galleryFilteredPictures = activeTabId === allLabelId || allLabelId === null
      ? galleryPictures
      : galleryPictures.filter((picture) => picture.labelid === activeTabId);

    const usedLabelIds = new Set(
      galleryPictures
        .map((picture) => picture.labelid)
        .filter((labelId) => labelId !== null && labelId !== undefined)
    );

    const visibleLabels = this.props.labels.filter((label) => {
      const labelId = Number(label.id);
      if (allLabelId !== null && labelId === allLabelId) {
        return true;
      }
      return usedLabelIds.has(labelId);
    });

    const activeLabelVisible = visibleLabels.some((label) => Number(label.id) === activeTabId);
    const safeActiveTabId = activeLabelVisible
      ? activeTabId
      : (allLabelId ?? Number(visibleLabels[0]?.id ?? activeTabId));

    const safeFilteredPictures = safeActiveTabId === allLabelId || allLabelId === null
      ? galleryPictures
      : galleryPictures.filter((picture) => picture.labelid === safeActiveTabId);

    const totalPages = Math.ceil(safeFilteredPictures.length / perPage)
    const picturesToShow = safeFilteredPictures.slice(offset, (offset + perPage))

    //console.log(picturesToShow);
    
    const panes = visibleLabels.map((label) => (
      {
        menuItem: `${label.name}`,
        index: `${label.id}`,
        render: () => (
          <Tab.Pane attached={false}>
            <h3>{label.name}</h3>
            {/* Ajout d'une condition si l'array de FilteredPictures est vide => message */}
            { safeFilteredPictures.length === 0 
              ? 
              <h4>Il n'y pas encore de photo dans cette section</h4> 
              :
              <CustomGallery
                className="custom-gallery" 
                photos={picturesToShow}
                allPictures={galleryPictures}
              />
            }
          </Tab.Pane>
        ),
      }
    ));
   
    return (
      <>
        <div id="custom-gallery">
          <Tab
            menu={{ secondary: true, pointing: true }}
            panes={panes}
            onTabChange={this.handleActiveTab}
          />

          { totalPages != 1 ?
            <Pagination
              activePage={activePage}
              boundaryRange={boundaryRange}
              onPageChange={this.handlePaginationChange}
              size='mini'
              siblingRange={siblingRange}
              totalPages={totalPages}
              // Heads up! All items are powered by shorthands, if you want to hide one of them, just pass `null` as value
              ellipsisItem={showEllipsis ? undefined : null}
              firstItem={showFirstAndLastNav ? undefined : null}
              lastItem={showFirstAndLastNav ? undefined : null}
              prevItem={showPreviousAndNextNav ? undefined : null}
              nextItem={showPreviousAndNextNav ? undefined : null}
            />
            : ''
          }
        </div>
      </>
    );
  }
};

GalleryCont.propTypes = {
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  pictures: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      place: PropTypes.string,
      description: PropTypes.string,
      customClass: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
      thumb: PropTypes.string.isRequired,
      labelId: PropTypes.number.isRequired,
    }).isRequired,
  ).isRequired,
};

export default GalleryCont;
